import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import ROUTES from '~/shared/constants/routes.const'
import { ButtonPrimary } from '~/components/Buttons/ButtonPrimary'
import { useGetProducts } from '~/booking/hooks/useGetProduct'
import { useGetLatestBookingQuery } from '~/redux/apis/bookings-api'
import { Product } from '~/types/product'
import { setTutorForSelfCartActionCreator, updateCartFromLatestBooking } from '~/redux/slices/cart'
import { useAppDispatch } from '~/redux/hooks'
import { TutorLevel, TutorPackage } from '~/types/booking'
import SVGImage from '~/components/Image/SVGImage'

const RENEWABLE_PACKAGE_TYPES = ['hours_8', 'hours_16']

export default function RenewablePackages(): React.ReactElement {
  const { t } = useTranslation('studentPanel')
  const { data: bookingProducts } = useGetProducts('tutorForSelf')
  const { data: latestBooking } = useGetLatestBookingQuery()
  const dispatch = useAppDispatch()
  const router = useRouter()

  const products = bookingProducts
    ? bookingProducts.tutoringProducts.filter((product) => {
        const tutorLevel = latestBooking && latestBooking.product ? latestBooking.product.tutorLevel : TutorLevel.TUTOR

        return RENEWABLE_PACKAGE_TYPES.includes(product.type) && product.tutorLevel === tutorLevel
      })
    : []

  const handleBuyPackage = (product: Product) => {
    dispatch(
      setTutorForSelfCartActionCreator({
        product,
      }),
    )
    router.push(ROUTES.BOOKING_FOR_SELF)
  }
  const handleRenewBooking = () => {
    if (latestBooking && latestBooking.preference && latestBooking.product) {
      dispatch(updateCartFromLatestBooking(latestBooking))
    }
    router.push(ROUTES.BOOKING_FOR_SELF)
  }

  return (
    <div className="my-3">
      {products.map((product) => (
        <ButtonPrimary
          className="mt-3 py-2 "
          isFullWidth
          key={product.id}
          noPadding
          onClick={() => handleBuyPackage(product)}
          size="medium"
        >
          {t(`buyPackage.${product.type}`)}
          {product.type === TutorPackage.HOURS_16 && (
            <SVGImage height={50} imageClassName="absolute -top-3 -right-3" srcKey="misc/popular-tag.svg" width={50} />
          )}
        </ButtonPrimary>
      ))}

      {latestBooking && (
        <ButtonPrimary
          className="w-full mt-3 py-2"
          isFullWidth
          noPadding
          onClick={() => handleRenewBooking()}
          size="medium"
        >
          {t(`buyPackage.latest`)}
        </ButtonPrimary>
      )}
    </div>
  )
}
